// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { color, xScreen } from "@keller/XDL/Utilities";
import { mergeWithCss } from "@keller/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

billingAddressStyles.titleText = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        css: css`
            margin-top: 10px;
            @media print {
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.border")};
                border-bottom: 0;
                font-size: 12px;
                line-height: 18px;
                padding: 8px;
                margin: 0;
            }
        `,
    }),
};

billingAddressStyles.addressDisplay = {
    wrapper: {
        css: css`
            flex-direction: column;
            padding-top: 0;
            border-radius: 4px;
            ${styledBoxStyle}

            ${xScreen("lte", "sm")} {
                padding-top: 15px;
            }

            @media print {
                border-radius: 0;
                padding: 8px;
                flex-grow: 1;
            }
        `,
    },
};

billingAddressStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
        @media print {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 0;
        }
    `,
};
